import { useQuery } from '@apollo/client'
import HeaderUser from 'components/HeaderUser/HeaderUser'

import { USER } from '@/graphql/queries/user'

const Container = props => {
  const userQuery = useQuery(USER)

  if (userQuery.loading || !userQuery.data?.me) {
    return null
  }

  const {
    avatar,
    username,
  } = userQuery.data.me

  return (
    <HeaderUser
      avatar={ avatar }
      username={ username }
      { ...props }
    />
  )
}

export default Container
